import { fetchAsObservable } from "fetcher!sofe";

export function postResetPassword(body) {
  return fetchAsObservable(`/forgot-password`, {
    method: "post",
    body,
  });
}
